var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('Table',{attrs:{"detail":_vm.detail,"submitText":"修改后提交"},on:{"send":_vm.send}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }